<template>
<footer class="block lg:flex w-full lg:justify-around">

  <div class="footer-left opacity-40 hidden lg:block w-full lg:w-1/3   text-left pl-5">
    106 West 56th Street
  </div>


  <div class="footer-logo m-auto lg:m-none  py-3 lg:py-0">


    <a href="http://savannafund.com" class="image-link link sav-link"><img src="/images/home//sav.png" alt="Savanna" /></a>

  </div>
  <div class="footer-logo m-auto lg:m-none py-3 lg:py-0">
    <a href="http://cbre.com" class="image-link link cbre-link"><img src="/images/home/cbre.png" alt="CBRE" /></a>
  </div>
  <div class="footer-logo  m-auto lg:m-none  py-3 lg:py-0">
    <a href="#" class="image-link link atom-link"><img src="/images/home/atom.png" alt="Atom" /></a>
  </div>

  <div class="footer-right w-full lg:w-1/3   lg:text-right text-center  lg:text-right py-10 lg:py-0 lg:pr-5 ">
    <div class="flex justify-center lg:justify-end">
    <a href="/pdf/2.2022-thesix-e-brochure.pdf">Download Brochure</a>
    <a href="https://www.instagram.com/thesix56/" target="_blank" class="pl-4">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.16217C15.2041 2.16217 15.5837 2.17441 16.849 2.23214C18.019 2.28549 18.6544 2.48098 19.0773 2.64532C19.6374 2.863 20.0371 3.12304 20.457 3.54293C20.877 3.96287 21.137 4.36261 21.3547 4.92274C21.519 5.34559 21.7145 5.98098 21.7679 7.15096C21.8256 8.41631 21.8379 8.79585 21.8379 11.9999C21.8379 15.2041 21.8256 15.5836 21.7679 16.849C21.7145 18.019 21.519 18.6544 21.3547 19.0772C21.137 19.6373 20.877 20.0371 20.4571 20.457C20.0371 20.8769 19.6374 21.1369 19.0773 21.3546C18.6544 21.519 18.019 21.7145 16.849 21.7678C15.5839 21.8255 15.2044 21.8378 12 21.8378C8.79564 21.8378 8.41619 21.8255 7.15098 21.7678C5.98099 21.7145 5.3456 21.519 4.92275 21.3546C4.36263 21.1369 3.96288 20.8769 3.54299 20.457C3.12309 20.0371 2.86301 19.6373 2.64532 19.0772C2.48098 18.6544 2.28549 18.019 2.23214 16.849C2.17441 15.5836 2.16217 15.2041 2.16217 11.9999C2.16217 8.79585 2.17441 8.41631 2.23214 7.15096C2.28549 5.98098 2.48098 5.34559 2.64532 4.92274C2.86301 4.36261 3.12304 3.96287 3.54299 3.54298C3.96288 3.12304 4.36263 2.863 4.92275 2.64532C5.3456 2.48098 5.98099 2.28549 7.15098 2.23214C8.41633 2.17441 8.79588 2.16217 12 2.16217ZM12 1.52588e-05C8.74101 1.52588e-05 8.33235 0.0138291 7.05243 0.0722283C5.77517 0.130485 4.90284 0.333357 4.13956 0.629974C3.35045 0.936641 2.68124 1.34696 2.01408 2.01407C1.34696 2.68123 0.93664 3.35044 0.63002 4.13954C0.333355 4.90283 0.130481 5.77515 0.0722247 7.05241C0.0138253 8.33233 1.14441e-05 8.74098 1.14441e-05 11.9999C1.14441e-05 15.259 0.0138253 15.6676 0.0722247 16.9475C0.130481 18.2248 0.333355 19.0971 0.63002 19.8604C0.93664 20.6495 1.34696 21.3187 2.01408 21.9859C2.68124 22.653 3.35045 23.0633 4.13956 23.3699C4.90284 23.6666 5.77517 23.8695 7.05243 23.9277C8.33235 23.9861 8.74101 23.9999 12 23.9999C15.259 23.9999 15.6677 23.9861 16.9476 23.9277C18.2249 23.8695 19.0972 23.6666 19.8605 23.3699C20.6496 23.0633 21.3188 22.653 21.9859 21.9859C22.6531 21.3187 23.0634 20.6495 23.3701 19.8604C23.6667 19.0971 23.8695 18.2248 23.9278 16.9475C23.9862 15.6676 24 15.259 24 11.9999C24 8.74098 23.9862 8.33233 23.9278 7.05241C23.8695 5.77515 23.6667 4.90283 23.3701 4.13954C23.0634 3.35044 22.6531 2.68123 21.9859 2.01407C21.3188 1.34696 20.6496 0.936641 19.8605 0.629974C19.0972 0.333357 18.2249 0.130485 16.9476 0.0722283C15.6677 0.0138291 15.259 1.52588e-05 12 1.52588e-05ZM12.0056 5.84341C8.60228 5.84341 5.84341 8.60228 5.84341 12.0055C5.84341 15.4088 8.60228 18.1677 12.0056 18.1677C15.4089 18.1677 18.1677 15.4088 18.1677 12.0055C18.1677 8.60228 15.4089 5.84341 12.0056 5.84341ZM12.0056 16.0055C9.79642 16.0055 8.00557 14.2147 8.00557 12.0055C8.00557 9.79641 9.79642 8.00557 12.0056 8.00557C14.2147 8.00557 16.0056 9.79641 16.0056 12.0055C16.0056 14.2147 14.2147 16.0055 12.0056 16.0055ZM18.4108 7.03613C19.2061 7.03613 19.8508 6.3914 19.8508 5.59615C19.8508 4.80085 19.2061 4.15613 18.4108 4.15613C17.6155 4.15613 16.9708 4.80085 16.9708 5.59615C16.9708 6.3914 17.6155 7.03613 18.4108 7.03613Z" fill="white"/>
      </svg>
    </a>
    </div>
  </div>
</footer>
</template>


<script>
export default {
  name: 'Footer'
}
</script>

<style>
footer {
padding: 3rem 0;
text-align: center;
font-size: 1rem;
letter-spacing: .2rem;
font-weight: 100;
text-transform: uppercase;
}
.footer-left,.footer-right{

}


  .link img{
        display: inline;
  }

    .sav-link img {
      height: 10px;
      width:  82px;
    }

    .cbre-link img {
      height: 12px;
      width: 48px;
    }

    .atom-link img {
      height: 20px;
        width:64px;
    }

    .image-link:hover {
      opacity: .5;
    }



    .footer-logo{
        width: 100px;
          text-align: center;
    }

    .link {

      max-width:none;
      width:auto;


      transition: .5s all;
    }


  </style>
